export const REQUIRED_MESSAGE = "Required field";
